export * from './IconOperator';
export { default as IconOperator } from './IconOperator';
